module.exports = __webpack_public_path__ + "static/img/jieguo.7278e55d.png";